import { useMemo } from 'react';
import type { IsoMonth } from '@/lib/api/types';
import { addMonths } from '@/lib/format/date';
import { useFormat } from '@/lib/format/useFormat';
import { Select, type SelectProps } from './form';

/**
 * Month picker as a native select ("تشرين الأول ٢٠٢٦" / "أكتوبر 2026"), since
 * <input type="month"> is missing in Safari and ignores the school locale.
 */
export function MonthSelect({
  value,
  onValueChange,
  back = 12,
  ahead = 12,
  ...props
}: Omit<SelectProps, 'value' | 'onChange'> & { value: IsoMonth; onValueChange: (m: IsoMonth) => void; back?: number; ahead?: number }) {
  const fmt = useFormat();
  const current = fmt.today().slice(0, 7);
  const months = useMemo(() => {
    const list: IsoMonth[] = [];
    for (let i = ahead; i >= -back; i--) list.push(addMonths(current, i));
    if (value && !list.includes(value)) list.push(value);
    return list.sort((a, b) => b.localeCompare(a));
  }, [current, back, ahead, value]);
  return (
    <Select {...props} value={value} onChange={(e) => onValueChange(e.target.value)}>
      {months.map((m) => (
        <option key={m} value={m}>
          {fmt.month(m)}
        </option>
      ))}
    </Select>
  );
}
